
/**
 * 根据权限配置菜单
 * 每一个menu项参数：label, path, number 显示提示数字, query 查询对象
 */
import Permit from '@/utils/permit'
let menus = []

let synthesizeMenu = {
	label: '综合报表', children: [
		{ label: '毛利估算报表', path: '/fnReport/fn-reports/reports/synthesize/cost-profit' }
	]
}
menus.push(synthesizeMenu)
if (Permit.extendModels().includes('oms')) {
	let omsMenu = {
		label: '订单管理', children: [
			{ label: '收款明细报表', path: '/fnReport/fn-reports/reports/oms/payment-detail' },
			{ label: '大客户排名报表', path: '/fnReport/fn-reports/reports/oms/wholesale-customer-ranking' },
			{ label: '热销产品排名报表', path: '/fnReport/fn-reports/reports/oms/product-sale-ranking' },
			{ label: '欠款明细报表', path: '/fnReport/fn-reports/reports/oms/diff-detail' },
			{ label: '销售业绩报表', path: '/fnReport/fn-reports/reports/oms/sale-performance' },
			// { label: '日报月报年报', path: '/fnReport/fn-reports/reports/oms/sale-line-chart' }
		]
	}
	menus.push(omsMenu)
}
if (Permit.extendModels().includes('pms')) {
	let pmsMenu = { label: '外采管理', children: [{ label: '供应商过交期报表', path: '/fnReport/fn-reports/reports/pms/supplier-over' }] }
	menus.push(pmsMenu)
}

if (Permit.extendModels().includes('mes')) {
	let mesMenu = {
		label: '生产管理', children: [
			{ label: '尾查报表', path: '/fnReport/fn-reports/reports/mes/qa' }
		]
	}
	menus.push(mesMenu)
}
if (Permit.extendModels().includes('wms')) {
	let mesMenu = {
		label: '库存管理', children: [
			{ label: '库存统计报表', path: '/fnReport/fn-reports/reports/wms/inventory-count' },
			{ label: '大货库存动销率报表', path: '/fnReport/fn-reports/reports/wms/moving-pin-rate' }

		]
	}
	menus.push(mesMenu)
}

export default {
	items: menus.filter(menu => menu.children.length != 0),
};